export default __webpack_public_path__ + "static/media/contact_bg.a35d9e96.jpg";